import { env } from '@skin-seoul/env-utils';

import axios, { AxiosInstance } from 'axios';
import qs from 'qs';

const DEFAULT_CART_URL = 'https://dev.skin-seoul.com/api';

const convertServerOriginToCartURL = (url: string) => {
  switch (url) {
    case 'https://dev-api.skin-seoul.com':
      return 'https://dev.skin-seoul.com/api';
    case 'https://staging-api.skin-seoul.com':
      return 'https://staging.skin-seoul.com/api';
    case 'https://api.skin-seoul.com':
      return 'https://skin-seoul.com/api';
    default:
      return DEFAULT_CART_URL;
  }
};

const getCartBaseURL = (): string => {
  return convertServerOriginToCartURL(env('NEXT_PUBLIC_ENV_SERVER_ORIGIN'));
};

export const createSkinSeoulCartClient = (_baseURL?: string): AxiosInstance => {
  const initialBaseURL = _baseURL ? convertServerOriginToCartURL(_baseURL) : getCartBaseURL();

  const isServer = typeof window === 'undefined';

  console.debug('[service/cartClient] Creating HTTP client:', {
    isServer,
    baseURL: initialBaseURL,
  });

  const instance = axios.create({
    baseURL: initialBaseURL,
    withCredentials: true,
    adapter: 'fetch',
    paramsSerializer: (params) => qs.stringify(params, { indices: false }),
  });

  // Fix for race condition: re-check baseURL on each request
  instance.interceptors.request.use((config) => {
    if (typeof window !== 'undefined') {
      const currentBaseURL = getCartBaseURL();
      const configBaseURL = config.baseURL || instance.defaults.baseURL;

      if (currentBaseURL !== DEFAULT_CART_URL && configBaseURL !== currentBaseURL) {
        config.baseURL = currentBaseURL;
        instance.defaults.baseURL = currentBaseURL;
      }
    }
    return config;
  });

  return instance;
};

export let cartClient: AxiosInstance = createSkinSeoulCartClient();

export const setCartClient = (instance: AxiosInstance) => {
  cartClient = instance;
};
